const ferries = {
  ferry: "Fähre", // translated
  ferries: "Fähren", // translated
  selectOriginPort: "Wählen Sie den Ursprungsport aus", // translated
  selectDestPort: "Wählen Sie den Zielport aus", // translated
  continue: "Weitermachen", // translated
  viewTimetables: "Fahrpläne anzeigen", // translated
  operator: "Operator", // translated
  cabin: "Kabine", // translated
  cabins: "Kabinen", // translated
  place: "Ort", // translated
  places: "Setzt", // translated
  seat: "Sitz", // translated
  seats: "Sitze", // translated
  seating: "Sitzplätze", // translated
  deckSpace: "Platz auf dem Deck", // translated
  compulsory: "obligatorisch", // translated
  departure: "Abfahrt", // translated
  total: "Gesamt", // translated
  back: "Zurück", // translated
  next: "Nächste", // translated
  duration: "Dauer", // translated
  return: "Zurückkehren", // translated
  prebook: "Vorreservieren", // translated
  travelInfo: "Reiseinformationen", // translated
  book: "Buch", // translated
  adults: "Erwachsene", // translated
  child: "Kind", // translated
  seniors: "Senioren", // translated
  senior: "Senior", // translated
  to: "Zu", // translated
  passenger: "Passagier", // translated
  details: "Einzelheiten", // translated
  currencyForTickets: "Die Währung für diese Tickets ist", // translated
  seatsError: "Die Anzahl der Passagiere entspricht nicht der Kapazität.", // translated
  title: "Titel", // translated
  firstName: "Vorname", // translated
  lastName: "Familienname, Nachname", // translated
  email: "Email", // translated
  phone: "Telefon", // translated
  dateOfBirth: "Geburtsdatum", // translated
  placeOfBirth: "Geburtsort", // translated
  groupLeader: "Gruppenführer", // translated
  isRequired: "Ist erforderlich", // translated
  charactersOnly: "Nur Charaktere", // translated
  latinCharactersAndSpacesOnly: "Nur lateinische Zeichen und Leerzeichen", // translated
  validEmail: "Keine gültige E-Mail", // translated
  atLeastOneAdult: "Mindestens 1 Erwachsener ist erforderlich.", // translated
  atLeastOneSenior: "Mindestens 1 Senior ist erforderlich.", // translated
  toastAlert: "Bitte korrigieren Sie alle Fehler in den untenstehenden Formularen.", // translated
  backToFerriesList: "Zurück zur Fährenliste", // translated
  bestPrice: "Bestpreis", // translated
  fastest: "Am schnellsten", // translated
  beforeDeparture: "Vor der Abfahrt", // translated
  perPerson: "pro Person", // translated
  notAvailableForOnlineBooking: "Nicht für die Online-Buchung verfügbar", // translated
  hurryLimitedAvailability: "Beeil dich! Begrenzte Verfügbarkeit", // translated
  berth: "Liegeplatz", // translated
  berths: "Liegeplätze", // translated
  sumOfSelectionNotEqualToPersons: "Die Summe Ihrer Auswahl entspricht nicht der Anzahl der Passagiere", // translated
  attemptToBook: "Sie haben versucht, insgesamt zu buchen", // translated
  seatsWhenYouHave: "Sitze, wenn Sie haben", // translated
  passengersTravelling: "reisende Passagiere", // translated
  withReturn: "mit Rückfahrkarten", // translated
  pleaseCorrectYourSelection: "Bitte korrigieren Sie Ihre Auswahl", // translated
  pleaseSelectUpTo: "Bitte wählen Sie bis zu", // translated
  accommodationTypes: "Unterkunftsarten", // translated
  selectionPrices: "Auswahlpreise", // translated
  yourCurrentTicket: "Ihr aktueller Tickettyp ist", // translated
  upgradeTo: "Upgraden auf", // translated
  wouldYouLikeToUpgrade: "Möchten Sie Ihren Tickettyp upgraden?", // translated
  backToTicketTypes: "Zurück zu den Ticketarten", // translated
  originPort: "Ursprungshafen", // translated
  destinationPort: "Zielhafen", // translated
  outboundDate: "Ausgangsdatum", // translated
  inboundDate: "Eingangsdatum", // translated
  passengers: "Passagiere", // translated
  hasReturn: "Hat Rückkehr", // translated
  passportNumber: "Ausweisnummer", // translated
  passportExpiryDate: "Ablaufdatum des Passes", // translated
  passportPlaceOfIssue: "Pass Ausstellungsort", // translated
  passportStartDate: "Startdatum des Reisepasses", // translated
  cityCode: "Postleitzahl", // translated
};

export default ferries;
